(function () {
  function q(r, s) { return [].slice.call(r.querySelectorAll(s)); }
  function fm(c) { return (c / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR', minimumFractionDigits: c % 100 ? 2 : 0, maximumFractionDigits: 2 }); }
  var ALL = ['renard', 'panda', 'herisson', 'singe', 'cerf', 'lapin', 'chat'];

  /* ---------- haut de fiche : galerie, motif, panier, barre collante ---------- */
  function initBuy(root) {
    q(root, '[data-hxp]').forEach(function (s) {
      if (s._hxp) return; s._hxp = 1;
      var P = JSON.parse(s.querySelector('[data-hxp-json]').textContent);
      var track = s.querySelector('[data-hxp-track]'), lis = q(s, '[data-hxp-track]>li'), ths = q(s, '[data-hxp-th]'), cnt = s.querySelector('[data-hxp-i]');
      var cur = 0;
      function show(i, smooth) {
        if (!lis.length) return; i = (i + lis.length) % lis.length; cur = i;
        track.scrollTo({ left: lis[i].offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
        mark(i);
      }
      function mark(i) {
        ths.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
        if (cnt) cnt.textContent = i + 1;
        lis.forEach(function (l, k) { var v = l.querySelector('video'); if (v && k !== i) { v.pause(); l.classList.remove('is-play'); } });
      }
      if (track) track.addEventListener('scroll', function () {
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        if (i !== cur && i >= 0 && i < lis.length) { cur = i; mark(i); }
      }, { passive: true });
      ths.forEach(function (t, k) { t.addEventListener('click', function () { show(k, true); }); });
      q(s, '[data-hxp-step]').forEach(function (b) { b.addEventListener('click', function () { show(cur + Number(b.getAttribute('data-hxp-step')), true); }); });
      q(s, '[data-hxp-vplay]').forEach(function (b) {
        b.addEventListener('click', function () { var l = b.closest('li'), v = l.querySelector('video'); if (!v) return; v.preload = 'auto'; v.controls = true; l.classList.add('is-play'); var p = v.play(); p && p.catch(function () {}); });
      });

      var form = s.querySelector('[data-hxp-form]'), idIn = form.querySelector('[name=id]'), qIn = form.querySelector('[name=quantity]');
      var btn = s.querySelector('[data-hxp-add]'), pills = q(s, '[data-hxp-pill]'), pick = s.querySelector('[data-hxp-pick]');
      var curV = P.variants.filter(function (x) { return String(x.id) === String(idIn.value); })[0] || P.variants[0];
      function setText(sel, t) { q(s, sel).forEach(function (e) { e.textContent = t; }); }
      function setVariant(v, user) {
        curV = v; idIn.value = v.id;
        var key = v.key;
        pills.forEach(function (p) { var on = p.getAttribute('data-key') === key; p.setAttribute('aria-checked', on ? 'true' : 'false'); p.tabIndex = on ? 0 : -1; });
        if (pick) { ALL.forEach(function (k) { pick.classList.remove('hxh-t--' + k); }); pick.classList.add('hxh-t--' + key); }
        var bar = document.querySelector('[data-hxp-bar]');
        if (bar) { ALL.forEach(function (k) { bar.classList.remove('hxh-t--' + k); }); bar.classList.add('hxh-t--' + key); }
        setText('[data-hxp-nm]', v.options[0]);
        setText('[data-hxp-quote]', v.quote || '');
        setText('[data-hxp-price]', fm(v.price));
        var on = v.cmp > v.price;
        q(s, '[data-hxp-cmp]').forEach(function (e) { e.hidden = !on; e.textContent = on ? fm(v.cmp) : ''; });
        q(s, '[data-hxp-pct]').forEach(function (e) { e.hidden = !on; e.textContent = on ? '−' + Math.floor((v.cmp - v.price) * 100 / v.cmp) + ' %' : ''; });
        q(document, '[data-hxp-bhead]').forEach(function (e) { e.src = v.sw; });
        q(document, '[data-hxp-bname]').forEach(function (e) { e.textContent = 'Tour ' + v.options[0].toLowerCase(); });
        q(document, '[data-hxp-bprice]').forEach(function (e) { e.textContent = fm(v.price); });
        [btn].concat(q(document, '[data-hxp-bar-add]')).forEach(function (b) { if (b) { b.disabled = !v.av; } });
        var lab = btn.querySelector('[data-hxp-addt]'); if (lab) lab.textContent = v.av ? btn.getAttribute('data-t-add') : btn.getAttribute('data-t-out');
        var sk = s.querySelector('[data-hxp-stock]'); if (sk) { sk.textContent = v.av ? sk.getAttribute('data-t-in') : sk.getAttribute('data-t-out'); var d = sk.parentNode.parentNode.querySelector('i'); if (d) d.classList.toggle('off', !v.av); }
        if (v.media) { lis.forEach(function (l, k) { if (l.getAttribute('data-media') === String(v.media)) show(k, !!user); }); }
        try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString()); } catch (e) {}
      }
      pills.forEach(function (b, k) {
        b.addEventListener('click', function () { var v = P.variants.filter(function (x) { return x.key === b.getAttribute('data-key'); })[0]; if (v) setVariant(v, true); });
        b.addEventListener('keydown', function (e) {
          var d = e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : (e.key === 'ArrowLeft' || e.key === 'ArrowUp' ? -1 : 0);
          if (d) { e.preventDefault(); var n = pills[(k + d + pills.length) % pills.length]; n.click(); n.focus(); }
        });
      });
      q(s, '[data-hxp-q]').forEach(function (b) { b.addEventListener('click', function () { qIn.value = Math.max(1, (parseInt(qIn.value, 10) || 1) + Number(b.getAttribute('data-hxp-q'))); }); });
      // etat initial (variante de l URL)
      setVariant(curV, false);

      var busy = false;
      function addCart() {
        if (btn.disabled || busy) return; busy = true; btn.classList.add('is-load');
        var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        var qty = Math.max(1, parseInt(qIn.value, 10) || 1), body = { items: [{ id: Number(idIn.value), quantity: qty }] };
        try { if (cart && cart.getSectionsToRender) { body.sections = cart.getSectionsToRender().map(function (x) { return x.id; }); body.sections_url = location.pathname; } } catch (e) {}
        fetch((s.getAttribute('data-add-url') || '/cart/add') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (res.status) throw res;
            busy = false; btn.classList.remove('is-load'); btn.classList.add('is-ok');
            var lab = btn.querySelector('[data-hxp-addt]'); if (lab) lab.textContent = btn.getAttribute('data-t-ok');
            setTimeout(function () { btn.classList.remove('is-ok'); if (lab) lab.textContent = btn.getAttribute('data-t-add'); }, 2400);
            var done = false;
            try { if (cart && cart.renderContents && res.sections) { cart.classList.remove('is-empty'); cart.renderContents(res); done = true; } } catch (e) {}
            if (!done) { fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { q(document, '.cart-count-bubble span[aria-hidden]').forEach(function (x) { x.textContent = c.item_count; }); }).catch(function () {}); }
            document.dispatchEvent(new CustomEvent('dx:cart-added', { detail: res }));
          })
          .catch(function () { busy = false; btn.classList.remove('is-load'); form.submit(); });
      }
      form.addEventListener('submit', function (e) { e.preventDefault(); addCart(); });
      q(document, '[data-hxp-bar-add]').forEach(function (b) { b.addEventListener('click', addCart); });

      // barre collante : visible quand le bouton principal n est plus a l ecran
      var bar = document.querySelector('[data-hxp-bar]');
      if (bar && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          var e = es[0], out = !e.isIntersecting, mob = window.innerWidth < 990;
          var show = out && (mob || e.boundingClientRect.top < 0);
          bar.classList.toggle('is-on', show); bar.setAttribute('aria-hidden', show ? 'false' : 'true');
          q(bar, 'button').forEach(function (b) { b.tabIndex = show ? 0 : -1; });
        }, { threshold: 0 }).observe(btn);
      }
      // liens vers le haut du bloc d achat
      q(document, '[data-hxp-top]').forEach(function (a) { a.addEventListener('click', function (e) { e.preventDefault(); s.scrollIntoView({ behavior: 'smooth', block: 'start' }); }); });
    });
  }

  /* ---------- videos clients ---------- */
  function initVid(root) {
    q(root, '[data-hxp-vids]').forEach(function (w) {
      if (w._hxp) return; w._hxp = 1;
      var dlg = w.querySelector('dialog'); if (!dlg) return;
      var v = dlg.querySelector('video');
      q(w, '[data-src]').forEach(function (b) {
        b.addEventListener('click', function () { v.src = b.getAttribute('data-src'); v.poster = b.getAttribute('data-poster') || ''; if (dlg.showModal) dlg.showModal(); var p = v.play(); p && p.catch(function () {}); });
      });
      function close() { v.pause(); v.removeAttribute('src'); v.load(); if (dlg.open) dlg.close(); }
      dlg.querySelector('button').addEventListener('click', close);
      dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });
      dlg.addEventListener('close', function () { v.pause(); });
    });
  }

  /* ---------- avis : filtres, voir plus, note affichee en haut de fiche ---------- */
  function initAvis(root) {
    q(root, '[data-hxp-avis]').forEach(function (w) {
      if (w._hxp) return; w._hxp = 1;
      var cards = q(w, '[data-r]'), per = parseInt(w.getAttribute('data-per'), 10) || 6, more = w.querySelector('[data-more]'), f = 'all', shown = per;
      function match(c) { return f === 'all' || (f === 'ph' && c.getAttribute('data-ph') === '1') || c.getAttribute('data-r') === f; }
      function apply() {
        var vis = 0;
        cards.forEach(function (c) {
          var ok = match(c), show = ok && vis < shown; if (ok) vis++;
          c.hidden = !show;
        });
        if (more) more.hidden = cards.filter(match).length <= shown;
      }
      q(w, '[data-f]').forEach(function (b) { b.addEventListener('click', function () { f = b.getAttribute('data-f'); shown = per; q(w, '[data-f]').forEach(function (x) { x.classList.toggle('is-on', x === b); }); apply(); }); });
      if (more) more.querySelector('button').addEventListener('click', function () { shown += per; apply(); });
      apply();
      // note en haut de fiche
      var avg = w.getAttribute('data-avg'), n = w.getAttribute('data-n');
      if (avg && n) q(document, '[data-hxp-rate]').forEach(function (r) {
        var star = '<svg class="hxp-star" viewBox="0 0 24 24"><path d="m12 2.8 2.8 5.9 6.4.8-4.7 4.4 1.2 6.4L12 17.2 6.3 20.3l1.2-6.4-4.7-4.4 6.4-.8z"/></svg>';
        var out = '<span class="st" aria-hidden="true">'; for (var i = 1; i <= 5; i++) { out += star.replace('class="hxp-star"', 'class="hxp-star' + (parseFloat(avg) >= i - 0.25 ? '' : ' off') + '"'); } out += '</span>';
        r.innerHTML = out + '<b>' + String(avg).replace('.', ',') + '/5</b><u>' + n + ' avis</u>'; r.hidden = false;
      });
    });
  }

  function init(root) { root = root || document; initBuy(root); initVid(root); initAvis(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
